/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import MitigationTasksModal from "./MitigationTasksModal.vue";
import MitigationDetailsModal from "./Mitigationdetailsmodal.vue";
import ManageMitigationModal from "./ManageMitigationModal.vue";

export default {
    name: "MitigationInfoModal",
    components: { 
        customModal,
        VPagination,
        MitigationTasksModal,
        MitigationDetailsModal,
        ManageMitigationModal,
        
    },
    props: {
        data: Object,
        fromPage: {
            type: String,
            default: ""
        }
    },
    emits: ["closeModal"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            loading: false,
            mitigationList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 1 ,
            defaultDate: "",
            showTasksModal: false,
            selectedMitigation: null,
            showMitigationDetailsModal: false,
            selectedMitigationForDetails: null,
            showManageMitigationModal: false,
            selectedMitigationForEdit: null, 
        };
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.defaultDate = localStorage.getItem("dateformat");
        if (this.data) {
            this.fetchMitigationDetails();
        }
    },

    watch: {
        data: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.currentPage = 1;
                    this.fetchMitigationDetails();
                }
            },
        },
    },

    methods: {
        async fetchMitigationDetails(page = this.currentPage) {
            this.loading = true;
            this.mitigationList = [];

            const mapExpanded = (list) => list.map(i => ({ ...i, expanded: false }));

            try {
                const response = await axios.get(
                   `${this.baseurl}/forms/ctq/getmitigationlist`,
                    {
                        params: {
                            StudyId: this.studyId,
                            RiskId: this.data.riskId,
                            pageindex: page,
                            pagesize: this.pageSize,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = response.data;

                if (result.entities && Array.isArray(result.entities)) {
                    this.mitigationList = mapExpanded(result.entities);
                    this.totalCount = result.totalCount || 0;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (Array.isArray(result)) {
                    this.mitigationList = mapExpanded(result);
                    this.totalCount = result.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (result) {
                    this.mitigationList = [{ ...result, expanded: false }];
                    this.totalCount = 1;
                    this.totalPages = 1;
                }

                this.currentPage = page;
            } catch (error) {
                console.error("Error fetching mitigation details:", error);
                this.mitigationList = [];
                this.totalCount = 0;
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },

        loadPage(page) {
            this.fetchMitigationDetails(page);
        },

        closeModal() {
            this.$emit("closeModal");
        },

        formatDate(data) {
            if (data) {
                return moment(data).format(this.defaultDate);
            }
            return "";
        },

        viewTasks(item) {
            this.selectedMitigation = item;
            this.showTasksModal = true;
        },

        closeTasksModal() {
            this.showTasksModal = false;
            this.selectedMitigation = null;
        },

        truncate(text, length = 120) {
            if (!text) return "";
            return text.length > length ? text.substring(0, length) + "..." : text;
        },

        toggleExpand(item) {
            item.expanded = !item.expanded;
        },

        viewMitigationDetails(item) {
            this.selectedMitigationForDetails = item;
            this.showMitigationDetailsModal = true;
        },

        openManageMitigationModal(item = null) {
            this.selectedMitigationForEdit = item;
            this.showManageMitigationModal = true;
        },

        closeManageMitigationModal() {
            this.showManageMitigationModal = false;
            this.selectedMitigationForEdit = null;
        },
        closeMitigationDetailsModal(){
            this.showMitigationDetailsModal = false
        }

    },
};